function next_Collection() {
  var next_collection = $('.collection-navigation li.active').next('li').find('.navfirsttitle').text();
  var next_collection_url = $('.collection-navigation li.active').next('li').find('a').attr('href');
  $('.defualt-next-collection .next-collection-url').attr('href', next_collection_url);
  $('.defualt-next-collection .next-collection-title').text(next_collection);
  if (next_collection_url == undefined) {
    $('.defualt-next-collection').hide();
  }
}
next_Collection();

function adjustCollectionBlockHeight() {
  const firstGridMetaElementHeight = document.querySelector('.grid-meta').offsetHeight;
  const collectionBlocks = document.querySelectorAll('.product-item--featured-media');
  collectionBlocks.forEach((block) => {
    block.style.height = `calc(100% - ${firstGridMetaElementHeight}px)`
  })
}

var advance = function advance() {
    $(".grid-meta").matchHeight({property:"height"});
     $(".top_content").matchHeight({property:"height"});
    adjustCollectionBlockHeight();
    handleFeaturedMediaVisibility();
}

function handleFeaturedMediaVisibility() {
  // Get current page number from the pagination element
  const paginationLink = document.querySelector('#AjaxinatePagination a');
  const currentPage = paginationLink ? parseInt(paginationLink.dataset.page) : 1;
  
  // Get all featured media blocks
  const featuredMediaBlocks = document.querySelectorAll('[data-featured-media-block="true"]');
  
  featuredMediaBlocks.forEach(block => {
    let shouldShow = false;
    
    // Determine which page calculation to use based on screen size
    if (window.innerWidth >= 1200) {
      // Desktop (4+ columns)
      const blockPage = parseInt(block.dataset.desktopPage);
      shouldShow = blockPage <= currentPage;
    } else if (window.innerWidth >= 992) {
      // Tablet (3 columns)
      const blockPage = parseInt(block.dataset.tabletPage);
      shouldShow = blockPage <= currentPage;
    } else {
      // Mobile
      const gridColumns = document.querySelector('#product-grid').getAttribute('data-mb');
      if (gridColumns === '1') {
        // 1 column mobile
        const blockPage = parseInt(block.getAttribute('data-mobile-1col-page'));
        shouldShow = blockPage <= currentPage;
      } else {
        // 2 column mobile (default)
        const blockPage = parseInt(block.getAttribute('data-mobile-2col-page'));
        shouldShow = blockPage <= currentPage;
      }
    }
    
    // Show or hide the block
    if (shouldShow) {
      block.style.display = '';
    } else {
      block.style.display = 'none';
    }
  });
}

window.addEventListener('DOMContentLoaded',function () {
  $(".grid-meta").matchHeight({property:"height"});
  $(".top_content").matchHeight({property:"height"});
  adjustCollectionBlockHeight();
  handleFeaturedMediaVisibility();
});

// Handle window resize to recalculate featured media visibility on breakpoint changes
window.addEventListener('resize', function() {
  handleFeaturedMediaVisibility();
});

window.infinitescroll = {
  scolljs: function () {
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      loadingText: '',
      callback: function() {
        advance();
        updateProductCardsWithColorVariantDataOnHover();
        updateDesktopProductCards();
        applyHoverEffect();
        add_product_cards();
        initCollectionGridToggle();
      },
      offset: 1000
    });
  }
}


function updateProductCardsWithColorVariantDataOnHover(container = document) {
  const productItems = container.querySelectorAll('.product-item:not(.product-item--featured-media)');
  productItems.forEach(product => {
    const colorLinks = product.querySelectorAll('.grid-colorlist li');
    const activeImage = product.querySelector('.normal-img .product-link');
    const productTitle = product.querySelector('.top_content h5 a');
    const titleContainer = product.querySelector('.top_content h5');
    const productPrice = product.querySelector('.bottom_content .normal-price .money');
    let comparePriceElement = product.querySelector('.bottom_content .compare-price .money');
    let compareWrapper = product.querySelector('.bottom_content .compare-price');
    const hiddenVariantImages = product.querySelectorAll('.hidden-variant-images .variant-image-container');
    const quickshopContainer = product.querySelector('.var_div');
    const quickViewButtonWrapper = product.querySelector('.quickviewbtn-wrapper');
    const quickviewBtn = quickshopContainer.querySelector('.quickviewbtn');
    const sizeGrid = quickshopContainer.querySelector('.size_grid');
    const proContent = product.querySelector('.pro_content');

    const originalTitle = productTitle ? productTitle.textContent : '';
    const originalPrice = productPrice ? productPrice.textContent : '';
    const originalComparePrice = comparePriceElement ? comparePriceElement.textContent : '';
    const originalQuickviewBtnTitle = quickviewBtn.getAttribute('data-title');
    const originalQuickviewBtn = quickViewButtonWrapper.innerHTML;
    let originalSizeGrid = '';
    if (sizeGrid) {
      originalSizeGrid = sizeGrid.innerHTML;
    }

    if (colorLinks) {
      colorLinks.forEach(link => {
        const handle = link.querySelector('a').getAttribute('data-handle');
        const linkElement = link.querySelector('a');
        linkElement.dataset.initialBorder = linkElement.style.border;
        const spanElement = linkElement.querySelector('span');
        const collectionTitle = link.querySelector('a').getAttribute('data-collection-title');
        let variantImage = null;
        if (hiddenVariantImages.length > 0) {
          variantImage = Array.from(hiddenVariantImages).find(div => div.getAttribute('data-product-handle') === handle);
        }
        let productData = null;

        const fetchData = () => {
          if (!productData) {
            fetch('/products/' + handle + '.js')
              .then(response => response.json())
              .then(data => {
                productData = data;
                updateProductData();
              })
              .catch(error => {
                console.error('An error occurred while fetching the product data.', error);
              });
          } else {
            updateProductData();
          }
        };

        const updateProductData = () => {
          const newTitle = productData.title;
          const newPrice = productData.price;
          const newComparePrice = productData.compare_at_price;
          const newVariants = productData.variants;

          if (newTitle && newPrice) {
            productTitle.textContent = newTitle;
            productPrice.textContent = `€${(newPrice / 100).toFixed(2)}`;
            titleContainer.classList.add('colour-swatch-title');

            compareWrapper = product.querySelector('.bottom_content .compare-price');
            comparePriceElement = compareWrapper ? compareWrapper.querySelector('.money') : null;

            if (newComparePrice && newComparePrice !== newPrice) {
              if (compareWrapper) {
                compareWrapper.innerHTML = `<span class="money">€${(newComparePrice / 100).toFixed(2)}</span>`;
                compareWrapper.style.display = 'inline';
              } else {
                const newCompareEl = document.createElement('span');
                newCompareEl.className = 'compare-price';
                newCompareEl.innerHTML = `<span class="money">€${(newComparePrice / 100).toFixed(2)}</span>`;
                productPrice.parentElement.appendChild(newCompareEl);
              }

              if (proContent && !proContent.classList.contains('compre-div')) {
                proContent.classList.add('compre-div');
              }

              productPrice.parentElement.style.color = ''; // Reset price color
            } else {
              if (compareWrapper) {
                compareWrapper.style.display = 'none';
              }

              if (proContent && proContent.classList.contains('compre-div')) {
                proContent.classList.remove('compre-div');
              }

              productPrice.parentElement.style.color = '#8B8B8B';
            }
          }
        };

        if (window.innerWidth < 991) {
          link.addEventListener('click', function(event) {
            event.preventDefault();

            const currentActive = product.querySelector('.variant-image-container.active');
            if (currentActive) {
              currentActive.classList.remove('active');
            }
            colorLinks.forEach(function(colorLink) {
              const linkElement = colorLink.querySelector('a');
              linkElement.style.border = '1px solid transparent';
            });

            const linkHref = link.querySelector('a').getAttribute('href');
            const firstColorLink = product.querySelector('.grid-colorlist li:first-child');
            const firstLinkHref = firstColorLink ? firstColorLink.querySelector('a').getAttribute('href') : null;

            if (linkHref === firstLinkHref) {
              if (variantImage) {
                variantImage.classList.remove('active');
              }

              quickViewButtonWrapper.innerHTML = originalQuickviewBtn;
            } else {
              if (variantImage) {
                variantImage.classList.add('active');
              }
            }

            fetchData();

            quickViewButtonWrapper.innerHTML = `
              <a href="#" class="quickviewbtn" data-handle="${handle}" data-title="${collectionTitle}">
                <span class="d-none d-lg-block">Quick view</span>
                <span class="d-block d-lg-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                    <path d="M9.11953 3.07992V1H2.87976V3.07992" stroke="white" stroke-width="0.5"/>
                    <rect x="0.530151" y="3.33008" width="10.9396" height="10.4196" stroke="white" stroke-width="0.5"/>
                  </svg>
                </span>
              </a>
            `;

            if (spanElement) {
              const borderColor = spanElement.style.backgroundColor;
              if (borderColor === 'rgb(255, 255, 255)' || borderColor === '#ffffff' || borderColor === '#fff' || borderColor === 'white') {
                linkElement.style.border = '1px solid #eee';
              } else {
                linkElement.style.border = `1px solid ${borderColor}`;
              }
            }
          });
        }
      });
    }
  });
}



async function updateDesktopProductCards(container = document) {
  if (window.innerWidth <= 991) return;

  const productItems = container.querySelectorAll('.product-item:not(.product-item--featured-media)');

  for (const product of productItems) {
    const colorLinks = product.querySelectorAll('.grid-colorlist li');
    const activeImage = product.querySelector('.normal-img .product-link');
    const productTitle = product.querySelector('.top_content h5 a');
    const productPrice = product.querySelector('.bottom_content .normal-price .money');

    let comparePriceWrapper = product.querySelector('.bottom_content .compare-price');
    let comparePrice = comparePriceWrapper?.querySelector('.money');

    
    if (!comparePriceWrapper) {
      comparePriceWrapper = document.createElement('span');
      comparePriceWrapper.className = 'compare-price';
      comparePriceWrapper.style.display = 'none';

      comparePrice = document.createElement('span');
      comparePrice.className = 'money';

      comparePriceWrapper.appendChild(comparePrice);

      const normalPriceContainer = product.querySelector('.bottom_content .normal-price');
      if (normalPriceContainer && normalPriceContainer.parentNode) {
        normalPriceContainer.parentNode.appendChild(comparePriceWrapper);
      }
    }

    
    const proContent = product.querySelector('.pro_content');
    if (comparePrice?.textContent?.trim()) {
      proContent?.classList.add('compre-div');
    }

    const hiddenVariantImages = product.querySelectorAll('.hidden-variant-images .variant-image-container');
    const originalTitle = productTitle?.textContent || '';
    const originalPrice = productPrice?.textContent || '';
    const originalCompare = comparePrice?.textContent || '';

    const defaultLi = product.querySelector('.grid-colorlist li.active');
    const defaultLink = defaultLi?.querySelector('a');

    colorLinks.forEach(link => {
      const a = link.querySelector('a');
      if (a) {
        a.dataset.initialBorder = a.style.border || '';
      }
    });

    const variantDataMap = {};
    const fetchPromises = [];

    colorLinks.forEach(link => {
      const aTag = link.querySelector('a');
      const handle = aTag?.dataset.handle;
      if (handle && !variantDataMap[handle]) {
        const fetchPromise = fetch(`/products/${handle}.js`)
          .then(res => res.json())
          .then(data => {
            variantDataMap[handle] = data;
          })
          .catch(err => {
            console.error(`Error fetching ${handle}:`, err);
            variantDataMap[handle] = null;
          });
        fetchPromises.push(fetchPromise);
      }
    });

    await Promise.all(fetchPromises);

    colorLinks.forEach(link => {
      const aTag = link.querySelector('a');
      const handle = aTag?.dataset.handle;
      const span = aTag?.querySelector('span');
      const variantImage = Array.from(hiddenVariantImages).find(div => div.dataset.productHandle === handle);

      link.addEventListener('pointerenter', () => {
        const data = variantDataMap[handle];
        if (!data) return;

        
        colorLinks.forEach(li => {
          li.classList.remove('active');
          const linkEl = li.querySelector('a');
          if (linkEl) linkEl.style.border = '1px solid transparent';
        });

        link.classList.add('active');

        
        productTitle.textContent = data.title;
        productPrice.textContent = `€${(data.price / 100).toFixed(2)}`;

        if (comparePrice) {
          const compareText = data.compare_at_price ? `€${(data.compare_at_price / 100).toFixed(2)}` : '';
          comparePrice.textContent = compareText;
          comparePriceWrapper.style.display = compareText ? 'inline' : 'none';

          
          if (compareText) {
            proContent?.classList.add('compre-div');
          } else {
            proContent?.classList.remove('compre-div');
          }

          productPrice.parentElement.style.color = compareText ? '' : '#8B8B8B';
        }

        if (variantImage) {
          activeImage.style.opacity = '0';
          activeImage.style.pointerEvents = 'none';

          variantImage.classList.add('active');
          variantImage.style.opacity = '1';
          variantImage.style.pointerEvents = 'auto';
        }

        if (span && aTag) {
          const bg = span.style.backgroundColor;
          aTag.style.border = ['#fff', 'white', 'rgb(255, 255, 255)', '#ffffff'].includes(bg)
            ? '1px solid #eee'
            : `1px solid ${bg}`;
        }
      });

      link.addEventListener('pointerleave', () => {
        
        productTitle.textContent = originalTitle;
        productPrice.textContent = originalPrice;

        if (comparePrice) {
          comparePrice.textContent = originalCompare;
          comparePriceWrapper.style.display = originalCompare ? 'inline' : 'none';

          
          if (originalCompare) {
            proContent?.classList.add('compre-div');
          } else {
            proContent?.classList.remove('compre-div');
          }

          productPrice.parentElement.style.color = '';
        }

        if (variantImage) {
          variantImage.classList.remove('active');
          variantImage.style.opacity = '0';
          variantImage.style.pointerEvents = 'none';
        }

        activeImage.style.opacity = '1';
        activeImage.style.pointerEvents = 'auto';

        colorLinks.forEach(li => {
          const linkEl = li.querySelector('a');
          if (linkEl) linkEl.style.border = '1px solid transparent';
        });

        if (defaultLi) defaultLi.classList.add('active');
        if (defaultLink) {
          const original = defaultLink.dataset.initialBorder || '';
          defaultLink.style.border = original || '1px solid transparent';
        }
      });
    });
  }
}





function generateSrcset(url) {
  const widths = [352, 832, 1000];
  return widths.map(width => `${url}?width=${width} ${width}w`).join(', ');
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 991) {
    updateDesktopProductCards();
  } else {
    updateProductCardsWithColorVariantDataOnHover();
  }
});

$(document).on('click', '.change-view', function (e) {
  e.preventDefault();
  $('body').toggleClass('active-model');
  var modalvalue = $('body').hasClass('active-model') ? 'No' : 'yes';  
  localStorage.setItem('modelView', modalvalue);
  /*setTimeout(function(){
    $('body').removeClass('sticky-up');
    $('body').addClass('sticky-down');
  },200);  */
});
var modelState = localStorage.getItem("modelView");
if(modelState == 'No'){
  $('body').addClass('active-model');
}
window.addEventListener('beforeunload', function() {
  localStorage.removeItem('modelView');
});
window.infinitescroll.scolljs();
document.addEventListener('scroll', function (e) {
    var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
    sessionStorage.scrollPos = document.documentElement.scrollTop;
    sessionStorage.totalpage = totalpage;
});
// $(".grid-meta").matchHeight({property:"height"});
//   if (!document.body.classList.contains('collection-sale')) {
//   if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {  	
//     var scrollTop = sessionStorage?.getItem('scrollPos')
//     window.scrollTo(0, 0);
//     scrollManualy(scrollTop);
//     function scrollManualy(scrollTop) {
//     scrollTop = parseInt(scrollTop);
//      const myTimeout = setTimeout(function () {
//         if (window.scrollY < scrollTop && window.scrollY !== (scrollTop - 150)) {
//                 window.scrollTo(0, scrollTop)
//               window.scrollTo(0, window.scrollY - 150)
//               clearTimeout(myTimeout);
//               scrollManualy(scrollTop)	
//           }else{
//           clearTimeout(myTimeout);
//         }
//       }, 1000);
//     }
//   }
// }

function saveLoadedProducts() {
  var loadedProducts = document.querySelector("#product-grid").innerHTML;
  sessionStorage.setItem('loadedProducts', loadedProducts);
  var scrollPosition = window.scrollY;
  sessionStorage.setItem('scrollPosition', scrollPosition);
  sessionStorage.setItem('collectionURL', window.location.href);

  var ajaxinatePagination = document.querySelector("#AjaxinatePagination a");
  if (ajaxinatePagination) {
    sessionStorage.setItem('ajaxinateHref', ajaxinatePagination.href);
    sessionStorage.setItem('ajaxinatePage', ajaxinatePagination.dataset.page);
  }
}

function restoreState() {
  if (window.location.pathname.includes('/collections')) {
    
    var scrollPosition = sessionStorage.getItem('scrollPosition');
    var loadedProducts = sessionStorage.getItem('loadedProducts');
    var collectionURL = sessionStorage.getItem('collectionURL');
    var ajaxinateHref = sessionStorage.getItem('ajaxinateHref');
    var ajaxinatePage = sessionStorage.getItem('ajaxinatePage');
    
    if (loadedProducts && collectionURL === window.location.href) {
      document.querySelector("#product-grid").innerHTML = loadedProducts;
      if (window.innerWidth >= 991) {
        updateDesktopProductCards();
      } else {
        updateProductCardsWithColorVariantDataOnHover();
      }
      sessionStorage.removeItem('loadedProducts');
    }
    if (scrollPosition && collectionURL === window.location.href) {
      window.scrollTo(0, scrollPosition);
      sessionStorage.removeItem('scrollPosition');
    }
    if (ajaxinateHref && ajaxinatePage && collectionURL === window.location.href) {
      var ajaxinatePagination = document.querySelector("#AjaxinatePagination a");
      if (ajaxinatePagination) {
        ajaxinatePagination.href = ajaxinateHref;
        ajaxinatePagination.dataset.page = ajaxinatePage;
      }
      sessionStorage.removeItem('ajaxinateHref');
      sessionStorage.removeItem('ajaxinatePage');
    }
  }
}

document.addEventListener('DOMContentLoaded', restoreState);

document.addEventListener('click', function(event) {
  if (event.target.closest('.snippet-product-grid a')) {
    saveLoadedProducts();
  }
});

// Add touchstart event listener for mobile devices
document.addEventListener('touchstart', function(event) {
  if (event.target.closest('.snippet-product-grid a')) {
    saveLoadedProducts();
  }
});

window.addEventListener('beforeunload', function() {
  sessionStorage.setItem('scrollPosition', window.scrollY);
});

document.querySelectorAll('.section-header a').forEach(anchor => {
  anchor.addEventListener('click', function() {
    sessionStorage.clear();
  });
  // Add touchstart event listener for mobile devices
  anchor.addEventListener('touchstart', function() {
    sessionStorage.clear();
  });
});

window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    restoreState();
  }
});
function initCollectionGridToggle() {
  const collView = document.querySelector(".coll-view");
  const collectionGrid = document.querySelector(".collection-grid");
  const gridOptions = document.querySelectorAll(".coll-view a");

  if (!collView || !collectionGrid || gridOptions.length === 0) return;

  let savedView = localStorage.getItem("collection_grid") || document.querySelector(".coll-view a.active")?.getAttribute('data-view');
  if (savedView) {
    localStorage.setItem("collection_grid", savedView);
    collectionGrid.setAttribute('data-mb', savedView);
  }

  gridOptions.forEach(grid => {
    grid.classList.toggle('active', grid.getAttribute('data-view') === savedView);
  });

  gridOptions.forEach((grid) => {
    grid.addEventListener("click", (e) => {
      e.preventDefault();

      const selectedView = grid.getAttribute("data-view");
      if (!selectedView) return;

      const productItems = document.querySelectorAll('.product-item');
      const centerY = window.innerHeight / 2;
      let closestProduct = null;
      let closestDistance = Infinity;

      productItems.forEach(item => {
        const rect = item.getBoundingClientRect();
        const distance = Math.abs(rect.top + rect.height / 2 - centerY);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestProduct = item;
        }
      });

      const closestProductId = closestProduct?.getAttribute("data-index");

      gridOptions.forEach(option => option.classList.remove("active"));
      grid.classList.add("active");

      localStorage.setItem("collection_grid", selectedView);
      collectionGrid.setAttribute("data-mb", selectedView);

      // Handle matchHeight based on grid view
      if (selectedView === '1') {
        // Destroy matchHeight and reset inline styles for 1-column mode
        $(".top_content").matchHeight({ remove: true });
        $(".grid-meta").matchHeight({ remove: true });
        $(".top_content").css('height', '');
        $(".grid-meta").css('height', '');
      } else if (selectedView === '2') {
        // Apply matchHeight for 2-column mode
        $(".top_content").matchHeight({property:"height"});
        $(".grid-meta").matchHeight({property:"height"});
      }

      // Update featured media visibility when grid view changes
      handleFeaturedMediaVisibility();

      if (closestProductId) {
        setTimeout(() => {
          const targetProduct = document.querySelector(`.product-item[data-index="${closestProductId}"]`);
          if (targetProduct) {
            const rect = targetProduct.getBoundingClientRect();
            const offsetTop = window.scrollY + rect.top + rect.height / 2 - window.innerHeight / 2;

            window.scrollTo({
              top: offsetTop,
              behavior: 'auto'
            });
          }
        }, 50);
      }
    });
  });
}


initCollectionGridToggle();

// function applyHoverEffect(){
//   if(window.innerWidth > 991){
//     document.querySelectorAll('.product-item').forEach(card => {
//       let mediaContainer = card.querySelector('.prod-cards_media-inr');
//       card.addEventListener('mouseenter', () => {
//         if(window.innerWidth > 991){
//           card.classList.add('active-prod-cards');
//           mediaContainer.scrollTo({ left: mediaContainer.scrollWidth, behavior: 'smooth' });
//         }
//       });
//       card.addEventListener('mouseleave', () => {
//         if(window.innerWidth > 991){
//           card.classList.remove('active-prod-cards');
//           mediaContainer.scrollTo({ left: 0, behavior: 'smooth' });
//         }
//       });
//     });
//   }
// }
// if(window.innerWidth > 991){
//   applyHoverEffect();
//   window.addEventListener('resize', () => {
//     applyHoverEffect();
//   });
// }
function applyHoverEffect(){
  document.querySelectorAll('.product-item').forEach(card => {
    let mediaContainer = card.querySelector('.prod-cards_media-inr');
    
    if(window.innerWidth > 991){
      // Desktop hover effects
      card.addEventListener('mouseenter', () => {
        card.classList.add('active-prod-cards');
        mediaContainer.scrollTo({ left: mediaContainer.scrollWidth, behavior: 'smooth' });
      });
      card.addEventListener('mouseleave', () => {
        card.classList.remove('active-prod-cards');
        mediaContainer.scrollTo({ left: 0, behavior: 'smooth' });
      });
    } else {
      // Mobile touch effects
      let touchStartX = 0;
      let touchStartY = 0;
      let isSwiping = false;

      // Reset to first image on load
      mediaContainer.scrollLeft = 0;

      card.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isSwiping = false;
      }, { passive: true });

      card.addEventListener('touchmove', (e) => {
        const touchCurrentX = e.touches[0].clientX;
        const touchCurrentY = e.touches[0].clientY;
        const deltaX = touchCurrentX - touchStartX;
        const deltaY = Math.abs(touchCurrentY - touchStartY);

        // Check if it's a horizontal swipe (more horizontal than vertical movement)
        if (Math.abs(deltaX) > 15 && Math.abs(deltaX) > deltaY) {
          if (!isSwiping) {
            e.preventDefault(); // Prevent page scroll
            isSwiping = true;
          }
        }
      }, { passive: false });

      card.addEventListener('touchend', (e) => {
        if (isSwiping) {
          const touchEndX = e.changedTouches[0].clientX;
          const swipeDistance = touchEndX - touchStartX;
          const containerWidth = mediaContainer.offsetWidth;
          
          // Much lower threshold for easier swiping
          if (swipeDistance < -30) {
            // Swipe left - show second image
            mediaContainer.scrollTo({ left: containerWidth, behavior: 'smooth' });
          } else if (swipeDistance > 30) {
            // Swipe right - show first image
            mediaContainer.scrollTo({ left: 0, behavior: 'smooth' });
          }
        }
        isSwiping = false;
      }, { passive: true });
    }
  });
}
applyHoverEffect();
window.addEventListener('resize', () => {
  applyHoverEffect();
});
function add_product_cards(){
  if(document.querySelectorAll('.variant-grid')) document.querySelectorAll('.variant-grid').forEach(sizeList => {
    sizeList.addEventListener('click', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'items': [{ 'id': sizeList.dataset.id, 'quantity': 1 }] })
      })
      .then(res => res.json())
      .then(() => {
        if (location.pathname.includes('/cart')) location.href = "/cart";
        else if (typeof load_cart == 'function') {
          load_cart();
          setTimeout(() => document.body.classList.add('open-drawer'), 500);
        } else location.href = "/cart";
      })
      .catch(console.error);
    });
  });
}
add_product_cards();